import { createAppAsyncThunk } from '@/domain/store.thunk';
import { translate } from '@/ui/i18n';

export const getUserInfos = createAppAsyncThunk(
  'auth/getUserInfos',
  async (_, { extra: { authGateway, snackbarGateway } }) => {
    try {
      const user = await authGateway.getUserInfos();
      return user;
    } catch (error) {
      snackbarGateway.error(translate('GetUserInfos.Message.error'));
      throw error;
    }
  },
);
